import { Text } from '#app/components/Primitives/Text.js';
import { BoltIcon } from '@contra/icons/icons';
import { styled } from 'styled-components';

const QuickResponderBadgeText = styled(Text)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;

  color: ${({ theme }) => theme.colorsV2.gray80};
`;

const LightningBoltIcon = styled(BoltIcon)`
  flex-shrink: 0;
  color: ${({ theme }) => theme.colorsV2.gray80};
`;

export const QuickResponderBadge = ({
  isQuickResponder,
}: {
  readonly isQuickResponder: boolean;
}) => {
  if (!isQuickResponder) {
    return null;
  }

  return (
    <QuickResponderBadgeText textStyle="bodyRegular">
      <LightningBoltIcon size={16} />
      Typically responds within 24 hours
    </QuickResponderBadgeText>
  );
};
